import Vue from "vue";
import msal from "vue-msal";
import config from '@/config';

Vue.use(msal, {
  auth: {
    clientId: config.VUE_APP_CLIENT_ID,
    authority: config.VUE_APP_LOGIN,
    redirectUri: config.VUE_APP_REDIRECT,
    validateAuthority: false,
  },
  request: {
    scopes: ['openid'],
  },
});
